import Cookies from 'js-cookie'

// Leaf module on purpose: i18n/config.ts (reached from src/bootstrap.ts) needs
// getCookieConsent, and importing it from ./dialog dragged the whole new-design
// component tree -- lexical, oidc-client-ts, lodash -- into the entry chunk.
// The window.CookieConsent definition lives here too so that capturing it below
// can never race with whichever module imports it first.
declare global {
  interface Window {
    CookieConsent: {
      set: (name: string, value: string, days: number) => void
      get: (name: string) => string | undefined
      hasConsent: () => boolean
      remove: (name: string) => void
    }
  }
}

window.CookieConsent = {
  set: function (name: string, value: string, days: number) {
    Cookies.set(name, value, { expires: days })
  },
  get: function (name: string) {
    return Cookies.get(name)
  },
  hasConsent: function () {
    return Boolean(Cookies.get('CookieConsent'))
  },
  remove: function (name: string) {
    Cookies.remove(name)
  }
}

export const CookieConsent = window.CookieConsent

export const getCookieConsent = () => {
  const raw = CookieConsent?.get('CookieConsent')

  if (!raw) return {}

  try {
    return JSON.parse(raw)
  } catch {
    return {}
  }
}
